import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { checkEmailFormAction, registrationAction } from "../../redux/actions";
import { CHECK_EMAIL_FORM_INITIAL } from "../../redux/initialStateConstants";
import { checkEmailCodeSagaAction } from "../../redux/sagaActions";

const CheckEmailForm = () => {
    const dispatch = useDispatch();
    const check_email_form = useSelector(state => state.check_email_form);
    const registration_form = useSelector(state => state.registration_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => {
                            dispatch(checkEmailFormAction(CHECK_EMAIL_FORM_INITIAL));
                            dispatch(registrationAction({
                                ...registration_form,
                                open: true
                            }));
                        } }/>
                        <div className="form__title">Проверка почты</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Проверочный код из письма</div>
                        <input type="text" className="input"
                               value={ check_email_form.code }
                               onInput={ event => dispatch(checkEmailFormAction({
                                   ...check_email_form,
                                   code: event.target.value
                               })) }
                        />
                        <div className="form__hint">Обычно письмо приходит в течение 60 секунд.</div>
                        <div className="form__hint">Если письмо не пришло, проверьте папку «спам» и указанный email адрес</div>
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(checkEmailCodeSagaAction({
                                code: check_email_form.code,
                                email: check_email_form.email
                            })) }
                        >Проверить код</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckEmailForm;